import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, connect } from 'react-redux'
import { Form, Card, Button, Badge, ListGroup } from 'react-bootstrap'
import FA from 'react-fontawesome'
import { toggleTodoList, fetchTodos, toggleTodo, toggleShowDone, closeTodoList } from '../../../redux/actions/todos'
import AddTodoButton from './AddTodoButton'
import __ from 'lodash'
import Moment from 'moment'
import 'moment/locale/pl'
import './todo.css'
import cn from 'classnames'

const TodosContainer = ({ todoListOpen, todos }) => {
    const dispatch = useDispatch()
    const buttonColor = todos && todos.length > 0 ? 'primary' : 'secondary'

    useEffect(() => {
        dispatch(fetchTodos())
    }, [todoListOpen, dispatch])
    return <div style={{ position: 'relative' }}>
        <Button title="Lista zadań" variant={buttonColor} onClick={() => dispatch(toggleTodoList())} >
            <FA name="tasks" />
            {(todos && todos.length > 0) && <Badge style={{ position: 'absolute', left: 25, top: 5 }} variant="warning" className="text-dark">{todos && todos.length}</Badge>}
        </Button >
        {todoListOpen && <TodoList width={500} small={true} todos={todos} />}
    </div>
}

const TodosList = ({ zIndex = 100, className, showDone, width, todos,
    small = false, compressed = false, kategoria, linkAddress, linkTitle,
    newTaskButtonLabel = "Nowe zadanie" }) => {
    const sortedTodos = __.reverse(__.sortBy(todos, ['kiedy']))
    const dispatch = useDispatch()
    return <>
        <Card className={className} style={{ width: width ? width : 'auto', zIndex: compressed ? 0 : zIndex }}>
            {!compressed && <Card.Header className={cn({ small })}>
                Lista zadań
            <span className="float-right">
                    <Form.Check
                        type="switch"
                        label="Pokaż zakończone"
                        id={"todoShowDone" + sortedTodos.length}
                        checked={showDone}
                        onChange={() => dispatch(toggleShowDone())}
                        name="showDone"
                    />
                </span>
            </Card.Header>}
            <Card.Body bsPrefix="null">
                <ListGroup variant="flush" style={{ maxHeight: 420, overflow: 'auto' }}>
                    {sortedTodos.length === 0 && <ListGroup.Item>
                        <div className={cn({ small })}>
                            Brak zadań do wyświetlenia. Dodaj nowe zadania używając linka poniżej.
                    </div>
                    </ListGroup.Item>}
                    {__.map(sortedTodos, todo => <TodoItem key={todo._id} small={small} {...todo} />)}
                </ListGroup>
            </Card.Body>
            <Card.Footer bsPrefix={compressed ? 'null' : ''}>
                <AddTodoButton
                    variant="link"
                    size={small ? 'sm' : ''}
                    kategoria={kategoria}
                    linkAddress={linkAddress}
                    linkTitle={linkTitle}
                    newTaskButtonLabel={newTaskButtonLabel} />
                {small && !compressed && <Button title="Zamknij" variant="link" className="float-right">
                    <FA className="text-secondary" name="times" onClick={() => dispatch(toggleTodoList())} />
                </Button>}
            </Card.Footer>
        </Card>
    </>
}

const TodoItem = ({ deleted, _id, done, small, kiedy, nazwa, kategoria, opis, linkAddress, linkTitle }) => {
    const dispatch = useDispatch()
    return <ListGroup.Item style={{ backgroundColor: (deleted ? '#ccc' : '') }}>
        <div className='clearfix'>
            <div className="float-right text-right">
                <div className={cn({ small }, "text-bold")} style={{
                    position: "sticky",
                    top: 0,
                    marginBottom: 20
                }}>
                    <span className={cn({ small }, "font-weight-bold text-primary bg-white")}>Data zadania: </span>
                    <span className="font-weight-bold text-danger font-italic bg-white">
                        {Moment(kiedy).format('ddd')}&nbsp;
                </span>
                    <span className="bg-white">
                        {Moment(kiedy).format('YYYY-MM-DD HH:mm')}
                    </span>
                </div>
                <div style={{ position: "sticky", top: 15, marginTop: -24 }}>
                    <Badge pill variant="info" className={`${kategoria}-badge`}>{kategoria}</Badge>
                </div>
            </div>
            <div className="float-left" style={{ paddingRight: 0, marginTop: -40, width: '100%' }}>
                <div className={cn({ small })}>
                    <FA title={done ? "Przywróć" : "Zakończ"} style={{ cursor: 'pointer' }} onClick={() => dispatch(toggleTodo('done', _id))}
                        name={done ? "check-circle" : 'circle'} className={cn('mr-2', done ? 'text-success' : 'text-black-50')}
                    />
                    <span className="font-weight-bold">{nazwa}</span><br />{opis}
                </div>
                {linkAddress && <div className={cn({ small }, 'mt-1')}>
                    <Link to={linkAddress} title='Zobacz więcej informacji' onClick={() => dispatch(closeTodoList())}>
                        {linkTitle}
                    </Link>
                </div>}
            </div>
        </div>
    </ListGroup.Item >
}

const mapStateToProps = (state, ownProps) => {
    let ret, todos = state.todos.todos
    if (ownProps && ownProps.linkAddress) {
        todos = __.filter(todos, todo => todo.linkAddress === ownProps.linkAddress)
    }
    todos = __.filter(todos, todo => {
        if (state.todos.showDone) {
            return true
        } else {
            if (!todo.done) return true
        }
    })
    ret = {
        todos: todos,
        todoListOpen: !!state.todos.todoListOpen,
        showDone: !!state.todos.showDone,
        ...ownProps
    }
    return ret
}

export default connect(mapStateToProps)(TodosContainer)
const cTodoList = connect(mapStateToProps)(TodosList)
export const TodoList = cTodoList